import { Prisma, buyerPreferences } from '@prisma/client';
import axiosInstance from '../api';

const buyerPreferencesService = {
  // Get the current user's preferences
  find: async (): Promise<buyerPreferences | null> => {
    try {
      const res = await axiosInstance.get<buyerPreferences>('/buyer-preferences');
      // If backend returns empty object, return null
      if (res.data && Object.keys(res.data).length === 0) {
        return null;
      }
      return res.data;
    } catch (error: any) {
      // If no preferences exist, return null instead of throwing
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  // Get specific preferences by ID
  get: async (id: string): Promise<buyerPreferences> => {
    const res = await axiosInstance.get<buyerPreferences>(`/buyer-preferences/${id}`);
    return res.data;
  },

  // Create new preferences for the user
  create: async (data: Prisma.buyerPreferencesCreateInput): Promise<buyerPreferences> => {
    const res = await axiosInstance.post<buyerPreferences>('/buyer-preferences', data);
    return res.data;
  },

  // Update existing preferences
  update: async (id: string, data: Prisma.buyerPreferencesUpdateInput): Promise<buyerPreferences> => {
    const res = await axiosInstance.patch<buyerPreferences>(`/buyer-preferences/${id}`, data);
    return res.data;
  },

  // Save preferences (creates or updates as needed)
  save: async (data: Prisma.buyerPreferencesCreateInput | Prisma.buyerPreferencesUpdateInput): Promise<buyerPreferences> => {
    try {
      // Try to get existing preferences
      const existing = await buyerPreferencesService.find();
      if (existing?.id) {
        // Update existing preferences
        return await buyerPreferencesService.update(existing.id, data as Prisma.buyerPreferencesUpdateInput);
      } else {
        // Create new preferences
        return await buyerPreferencesService.create(data as Prisma.buyerPreferencesCreateInput);
      }
    } catch (error) {
      console.error('Error saving preferences:', error);
      throw error;
    }
  },

  // Delete preferences
  delete: async (id: string): Promise<void> => {
    await axiosInstance.delete(`/buyer-preferences/${id}`);
  },
};

export default buyerPreferencesService;